// Theme configuration colors use HSL components without the hsl() wrapper.
export const getDarkModeColor = (color: string, background = false): string => {
  const [hue, saturation] = color.split(" ");
  return `${hue} ${Math.min(parseFloat(saturation), background ? 20 : 55)}% ${background ? 16 : 68}%`;
};
